import * as React from 'react';
import { Badge } from 'reactstrap';
import { CredentialStatus } from '../../../../types';
import LightTooltip, {
  TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE,
} from '../../../../widgets/LightTooltip';
import Icon, { IconType } from '../../../../widgets/Icons';

type StatusInfo = {
  label: string;
  tooltip: string;
  color: string;
  icon: IconType;
};

const STATUS_INFO: Record<CredentialStatus, StatusInfo> = {
  [CredentialStatus.ACTIVE]: {
    label: 'Connected',
    tooltip:
      'Account is connected and providing security insights to your CST.',
    icon: Icon.Check,
    color: 'success',
  },
  [CredentialStatus.DEACTIVATING]: {
    label: 'Disconnection pending',
    tooltip: 'Account is in the process of being disconnected by your CST.',
    icon: Icon.X,
    color: 'warning',
  },
  [CredentialStatus.CREATE]: {
    label: 'Connection pending',
    tooltip: 'Account is in the process of being connected by your CST.',
    icon: Icon.Plus,
    color: 'warning',
  },
  [CredentialStatus.EDIT]: {
    label: 'Connection pending',
    tooltip: 'Account is in the process of being edited by your CST.',
    icon: Icon.Pencil,
    color: 'warning',
  },
  [CredentialStatus.ERROR]: {
    label: 'Not connected',
    tooltip:
      'Account is not connected due to an error. Please contact your CST.',
    icon: Icon.Prohibited,
    color: 'danger',
  },
};

type Props = {
  status: CredentialStatus;
};

export const ColumnStatus: React.FunctionComponent<Props> = ({ status }) => {
  const { label, color, icon: StatusIcon, tooltip } = STATUS_INFO[status];
  return (
    <LightTooltip
      block
      tooltip={tooltip}
      delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
      placement={'top'}
      size={'lg'}
    >
      <Badge color={color} className="status-badge cursor-question">
        <StatusIcon size={14} className="mr-2" />
        {label}
      </Badge>
    </LightTooltip>
  );
};
